<template>
  <div id="wrapper">
    <!-- <h1>管理機能：ユーザ管理</h1> -->
    <div id="manage-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- ViewTitleBox -->
      <div class="ibox-tools view-title">
        <h1 class="info-menu view-name">
          <img src="static/img/assets/nav_manage_on_2.png" alt="">
          {{$t('userManageStr')}}
        </h1>
        <span class="info-right">
        </span>
      </div>
      <!-- /ViewTitleBox -->
      <manage-wrapper-component require-admin>
        <!-- MainView -->
        <div fluid class="container mb-0">
          <b-row>
            <b-col cols="12" md="7" xl="8">
              <b-form-group horizontal :label="$t('searchLabelStr')" :label-cols="2">
                <b-form-input v-model="filter" :placeholder="$t('inputStr')"/>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="5" xl="4">
              <b-form-group horizontal :label="$t('selectKeyStr')" :label-cols="6">
                <b-form-select v-model="searchKey" :options="sortOptions" size="lg">
                  <option slot="first" :value="null">-- {{$t('allStr')}} --</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4"  xl="3">
              <b-form-group horizontal :label="$t('AdministStr')" :label-cols="6">
                <b-form-select :options="isManagerToggleStr" v-model="searchToggle.isManager" size="lg"/>
              </b-form-group>
            </b-col>
            <b-col cols="4"  xl="3">
              <b-form-group horizontal :label="$t('enableOrDisableStr')" :label-cols="6">
                <b-form-select :options="isInvalidToggleStr" v-model="searchToggle.isInvalid" size="lg"/>
              </b-form-group>
            </b-col>
            <b-col cols="4"  xl="3">
              <b-form-group horizontal :label="$t('perPageStr')" :label-cols="6">
                <b-form-select :options="pageOptions" v-model="perPage" size="lg"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="pagination-bar">
            <b-col cols="4">
              <label>Showing:</label> {{ totalRows }} ( Total: {{ usersTbl.length }} / Last Month: {{ lastMonthUsersCount }})
            </b-col>
            <b-col cols="4" offset="4">
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" align="right"/>
            </b-col>
          </b-row>
        </div>
        <article class="wrapper wrapper-content main-column w-100">
          <section class="animated fadeInRight" @click.self="open = false">
            <div class="ibox">
              <!-- <div class="ibox-content flex-option">
                <div class="ibox-child" style="border-bottom: 3px solid #999;"> -->
                  <b-table responsive hover caption-top
                    :items="usersList"
                    :fields="tblFields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filterByKeyText"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :fixed="true"
                    @filtered="onFiltered">
                    <!-- <template slot="table-caption">
                      Showing: {{ totalRows }} ( Total: {{ usersTbl.length }} )
                    </template> -->
                    <template slot="isAdmin" slot-scope="row">
                      <div @click.stop="onChangeIsAdmin(row)" :class="{'cursor-div': !checkUnclickableIsAdmin(row)}">
                        <toggle-button :sync="true"
                          :value="checkIsAdmin(row.value)"
                          :color="{unchecked: '#E85050', checked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': checkUnclickableIsAdmin(row)}"
                          :labels= "isAdminToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                    <template slot="isForceBrowsing" slot-scope="row">
                      <div @click.stop="onChangeIsForceBrowsing(row)" :class="{'cursor-div': !checkUnclickableIsForceBrowsing(row)}">
                        <toggle-button :sync="true"
                          :value="checkIsForceBrowsing(row.value)"
                          :color="{unchecked: '#E85050', checked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': checkUnclickableIsForceBrowsing(row)}"
                          :labels= "isManagerToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                    <template slot="isManager" slot-scope="row">
                      <div @click.stop="onChangeIsManager(row)" :class="{'cursor-div': !checkUnclickableIsManager(row)}">
                        <toggle-button :sync="true"
                          :value="checkIsManager(row.value)"
                          :color="{unchecked: '#E85050', checked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': checkUnclickableIsManager(row)}"
                          :labels= "isManagerToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                    <template slot="unavailable" slot-scope="row">
                      <div @click.stop="onChangeUnavailable(row)" :class="{'cursor-div': !checkUnclickableUnavailable(row)}">
                        <toggle-button :sync="true"
                          :value="row.value"
                          :color="{checked: '#E85050', unchecked: '#7AE197'}"
                          :disabled="true"
                          :class="{'unclickable': checkUnclickableUnavailable(row)}"
                          @change="onChangeUnavailable(row)"
                          :labels= "isInvalidToggleStr"
                          :width="75"/>
                      </div>
                    </template>
                    <template slot="email" slot-scope="row">
                      <div>
                        <span>{{ (row.value || '').split('\t')[0] }}</span>
                        <template v-if="isDeveloper">
                          <br>
                          <span>{{ (row.value || '').split('\t')[1] }}</span>
                        </template>
                      </div>
                    </template>
                    <template slot="userInfo" slot-scope="row">
                      <div class="userInfo">
                          <div class="search-userimg">
                            <img v-if="row.value && row.value['userIcon']" :alt="row.value['userName']" :src="row.value['userIcon']" class="img-circle">
                            <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                          </div>
                          <!-- <dl>
                            <dd><span class="userName">{{ row.value && row.value['userName'] }}</span></dd>
                          </dl> -->
                          <div>
                            <span class="userName">{{ row.value && row.value['userName'] }}</span>
                          </div>
                        </div>
                    </template>
                    <template slot="dept" slot-scope="row">
                      <div class="userItem">
                        <dl>
                          <dd><span class="userDept">{{ row.value }}</span></dd>
                        </dl>
                      </div>
                    </template>
                    <template slot="deleteUser" slot-scope="row">
                      <div class="userItem">
                        <template>
                          <div @click="deleteUser(row)" class="center-align" :class="{'cursor-div': !checkUnclickableIsAdmin(row)}">
                            <button class="btn-userDelete">{{$t('delete')}}</button>
                          </div>
                        </template>
                      </div>
                    </template>
                    <template slot="latestAccess" slot-scope="row">
                      <div class="userItem">
                        <dl>
                          <dd><span class="userName" v-if="row.value && row.value['timestamp']">{{ row.value['timestamp'] | preparedTime }}</span></dd>
                        </dl>
                      </div>
                    </template>
                  </b-table>
                <!-- </div>
              </div> -->
            </div>
          </section>
        </article>
      </manage-wrapper-component>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CommonJs from '@/js/common'
import Vue from 'vue'
import moment from 'moment'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
const firebase = require('firebase')
// Required for side-effects
require('firebase/functions')

// import ManageUserItem from '@/components/Manage/ManageUserItem'
// import ManageUserItemDetail from '@/components/Manage/ManageUserItemDetail'

export default {
  name: 'ManageUsers',
  mixins: [CommonJs],
  components: {
    // ManageUserItem,
    // ManageUserItemDetail
    ManageWrapperComponent
  },
  data: function () {
    return {
      users: {},
      open: false,
      usersTbl: [],
      totalRows: 0,
      filter: null,
      searchKey: null,
      searchToggle: {
        isManager: 'blank',
        isInvalid: 'blank',
        isAdmin: 'blank',
        isForceBrowsing: 'blank'
      },
      toggleKeyBool: {
        blank: null,
        checked: true,
        unchecked: false
      },
      sortDesc: false,
      sortBy: null,
      currentPage: 1,
      sortDirection: 'desc',
      pageOptions: [20, 50, 100],
      perPage: 20,
      managersCount: 0,
      adminsCount: 0,
      developersCount: 0,
      lastMonthUsersCount: 0,
      detail: ''
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'ManageUsers'
    },
    tblFields () {
      return [
        {
          key: 'isAdmin',
          label: this.$t('AdminUserStr'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'isForceBrowsing',
          label: this.$t('forceBrowsingUserStr'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'isManager',
          label: this.$t('managerUserStr'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'unavailable',
          label: this.$t('invalidUserStr'),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'email',
          label: this.$t('placeholderMailString') + (this.isDeveloper ? '<br>' + this.$t('userIdStr') : ''),
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'userInfo',
          label: this.$t('userBtnTitle'),
          class: 'align-middle',
          sortable: false
        },
        {
          key: 'dept',
          label: this.$t('departmentStr'),
          class: 'align-middle',
          sortable: false
        },
        {
          key: 'deleteUser',
          // label: this.$t('deleteUser'),
          label: 'ユーザー削除',
          class: 'align-middle',
          sortable: false
        },
        {
          key: 'latestAccess',
          label: this.$t('latestAccessStr'),
          class: 'align-middle',
          sortable: true
        }
      ]
    },
    isManagerToggleStr () {
      return {
        unchecked: this.$t('notManagerUserStr'),
        checked: this.$t('managerUserStr'),
        blank: 'ALL'
      }
    },
    isInvalidToggleStr () {
      return {
        checked: this.$t('invalidStr'),
        unchecked: this.$t('notInvalidStr'),
        blank: 'ALL'
      }
    },
    isAdminToggleStr () {
      return {
        checked: this.$t('AdminUserStr'),
        unchecked: this.$t('notManagerUserStr'),
        blank: 'ALL'
      }
    },
    sortOptions () {
      return [
        {
          value: 'email',
          text: this.$t('placeholderMailString')
        },
        {
          value: 'userName',
          text: this.$t('userBtnTitle')
        },
        {
          value: 'dept',
          text: this.$t('departmentStr')
        }
      ]
    },
    ...mapGetters('users/', [
      'getUsers'
    ]),
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement'
    ]),
    ...mapGetters('_meta/', [
      'getMetaUsersList',
      'getMetaIsDeveloper',
      'getMetaIsManager',
      'getMetaIsAdmin'
    ]),
    ...mapGetters('latestAccess/', [
      'getLatestAccess'
    ]),
    isManager: function () {
      return this.getMetaIsManager
    },
    isAdmin: function () {
      return this.getMetaIsAdmin
    },
    isDeveloper: function () {
      return this.getMetaIsDeveloper
    },
    usersList () {
      const metauserslist = this.getMetaUsersList
      // TODO: getUsers の排除
      const users = this.getUsers
      let userslist = {}
      let userstbl = []
      this.managersCount = 0
      this.adminsCount = 0
      this.developersCount = 0
      const latestAccess = this.getLatestAccess
      for (let uid of Object.keys(metauserslist)) {
        if (metauserslist[uid].isDeveloper) {
          // console.log('usersList:isDeveloper', uid, metauserslist[uid])
          if (!this.isDeveloper) {
            // console.log(' -> * Ignore.')
            continue
          } else {
            this.developersCount++
          }
        }
        if (metauserslist[uid].isDeleted) {
          // console.log('usersList:isDeleted', uid, metauserslist[uid])
          // console.log(' -> * Ignore.')
          continue
        }
        Vue.set(userslist, uid, metauserslist[uid])
        if (userslist[uid].isManager) {
          this.managersCount += 1
        }
        if (userslist[uid].isAdmin) {
          this.adminsCount += 1
        }
        userslist[uid].isRegist = false
        if (users.hasOwnProperty(uid)) {
          userslist[uid].isRegist = true
          userslist[uid].userId = uid
          userslist[uid].email = [(userslist[uid].email || '').split('\t')[0], uid].join('\t')
          let u = users[uid]
          userslist[uid].latestAccess = latestAccess.hasOwnProperty(uid) ? latestAccess[uid] : {}
          userslist[uid].userInfo = (u.hasOwnProperty('userInfo')) ? u.userInfo : {}
          userslist[uid].dept = (u.hasOwnProperty('userInfo')) ? (u.userInfo.hasOwnProperty('dept') ? u.userInfo.dept : '') : ''
          // console.log('usersList:userslist userInfo', uid, userslist[uid])
        }
        userstbl.push(userslist[uid])
      }
      this.usersTbl = userstbl
      // console.log(this.usersTbl)
      return userstbl
    // },
    // countAvailableUsersLastMonth () {
    //   const countAvailableUsers = this.$firebase.functions().httpsCallable('countAvailableUsersLastMonth')
    //   return countAvailableUsers().then(val => {
    //     console.log('countAvailableUsersLastMonth:', val)
    //     if (val.data && val.data.status && val.data.status === 'ok') {
    //       return val.data.count || 0
    //     }
    //     return 0
    //   }).catch(err => {
    //     console.log('countAvailableUsersLastMonth:', err)
    //     return 0
    //   })
    }
  },
  mounted: function () {
    this.users = this.getUsers
    this.$store.dispatch('latestAccess/GET_LATEST_ACCESS')
  },
  updated: function () {
    console.log('updated', new Date().toISOString(), this.searchToggle)
    this.countAvailableUsersLastMonth()
  },
  destroyed: function () {
    this.$store.dispatch('latestAccess/UNBIND_LATEST_ACCESS')
  },
  methods: {
    manageUser: function (user, uid) {
      console.log('manageUser:', user, uid)
      this.detail = { ...user, userId: uid }
      this.open = true
    },
    onChangeUnavailable: function (row) {
      console.log('onChangeUnavailable:', row, this.usersTbl[row.index], row.item)
      if (this.checkUnclickableUnavailable(row)) { return }
      this.showRoleInvalidSweetAlert(row, 'unavailable')
    },
    onChangeIsManager: function (row) {
      console.log('onChangeIsManager:', row, this.usersTbl[row.index], row.item)
      if (this.checkUnclickableIsManager(row)) { return }
      this.showRoleInvalidSweetAlert(row, 'isManager')
    },
    onChangeIsAdmin: function (row) {
      console.log('onChangeIsAdmin:', row, this.usersTbl[row.index], row.item)
      if (this.checkUnclickableIsAdmin(row)) { return }
      this.showRoleInvalidSweetAlert(row, 'isAdmin')
    },
    onChangeIsForceBrowsing: function (row) {
      console.log('onChangeIsForceBrowsing:', row, this.usersTbl[row.index], row.item)
      if (this.checkUnclickableIsForceBrowsing(row)) { return }
      this.showRoleInvalidSweetAlert(row, 'isForceBrowsing')
    },
    deleteUser: function (row) {
      console.log('deleteUser:', row, this.usersTbl[row.index], row.item)
      if (this.checkUnclickableIsManager(row)) { return }
      this.showRoleInvalidSweetAlert(row, 'deleteUser')
    },
    showRoleInvalidSweetAlert (row, target) {
      console.log('showRoleInvalidSweetAlert:', row, target)
      const setUserUnavailable = firebase.functions().httpsCallable('setUserUnavailable')
      const setUserRoleIsManager = firebase.functions().httpsCallable('setUserRoleIsManager')
      const setUserRoleIsAdmin = firebase.functions().httpsCallable('setUserRoleIsAdmin')
      const setUserRoleIsForceBrowsing = firebase.functions().httpsCallable('setUserRoleIsForceBrowsing')
      const deleteUser = firebase.functions().httpsCallable('setDeleteFlagToUser')
      const swalTitle = '更新してよろしいですか？'
      const loadingTitle = '更新中'
      this.$swal({
        title: swalTitle,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success',
        cancelButtonColor: '#f64846',
        cancelButtonClass: 'btn btn-danger',
        animation: false,
        customClass: 'animated fadeInUp',
        width: '35rem',
        position: 'center',
        padding: '2rem'
      }).then((result) => {
        if (result.value) {
          this.$swal({
            title: loadingTitle,
            confirmButtonClass: 'btn btn-success',
            animation: false,
            customClass: 'animated fadeInUp',
            width: '35rem',
            position: 'center',
            padding: '2rem',
            onBeforeOpen: () => {
              this.$swal.showLoading()
              switch (target) {
                case 'unavailable':
                  setUserUnavailable({
                    targetUserId: row.item.userId,
                    unavailable: !row.item.unavailable
                  }).then(() => {
                    this.$swal.close()
                  })
                  break
                case 'isManager':
                  setUserRoleIsManager({
                    targetUserId: row.item.userId,
                    isManager: !row.item.isManager
                  }).then(() => {
                    this.$swal.close()
                  })
                  break
                case 'isAdmin':
                  setUserRoleIsAdmin({
                    targetUserId: row.item.userId,
                    isAdmin: !row.item.isAdmin
                  }).then(() => {
                    this.$swal.close()
                  })
                  break
                case 'isForceBrowsing':
                  setUserRoleIsForceBrowsing({
                    targetUserId: row.item.userId,
                    isForceBrowsing: !row.item.isForceBrowsing
                  }).then(() => {
                    this.$swal.close()
                  })
                  break
                case 'deleteUser':
                  deleteUser({
                    targetUserId: row.item.userId
                  }).then(() => {
                    this.$swal.close()
                  })
                  break
              }
            }
          })
        }
      })
    },
    checkUnclickableIsManager (row) {
      return (row.item.userId === this.getUserId) || (!row.item.userId) || (this.managersCount === 1 && this.checkIsManager(row.value))
    },
    checkUnclickableIsAdmin (row) {
      return (row.item.userId === this.getUserId) || (!row.item.userId) || (this.adminsCount === 1 && this.checkIsAdmin(row.value))
    },
    checkUnclickableIsForceBrowsing (row) {
      return (row.item.userId === this.getUserId) || (!row.item.userId) || (this.adminsCount === 1 && this.checkIsForceBrowsing(row.value))
    },
    checkUnclickableUnavailable (row) {
      return row.item.userId === this.getUserId || !row.item.userId
    },
    filterByKeyText: function (data) {
      if (this.searchToggle.isManager !== 'blank') {
        if (this.toggleKeyBool[this.searchToggle.isManager] !== (data.isManager ? data.isManager : false)) { return false }
      }
      if (this.searchToggle.isAdmin !== 'blank') {
        if (this.toggleKeyBool[this.searchToggle.isAdmin] !== (data.isAdmin ? data.isAdmin : false)) { return false }
      }
      if (this.searchToggle.isInvalid !== 'blank') {
        if (this.toggleKeyBool[this.searchToggle.isInvalid] !== (data.unavailable ? data.unavailable : false)) { return false }
      }
      if (!this.filter || this.filter === '') { return true }
      const reg = new RegExp(this.filter.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi')
      const strs = {
        email: data.email || '',
        userName: (data.userInfo && data.userInfo.userName) || '',
        dept: (data.userInfo && data.userInfo.dept) || ''
      }
      if (strs.hasOwnProperty(this.searchKey)) {
        return reg.test(strs[this.searchKey])
      } else {
        return Object.keys(strs).some(x => { return reg.test(strs[x]) })
      }
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    checkIsManager: function (value) {
      return value === undefined ? false : value
    },
    checkIsAdmin: function (value) {
      return value === undefined ? false : value
    },
    checkIsForceBrowsing: function (value) {
      return value === undefined ? false : value
    },
    countAvailableUsersLastMonth: function () {
      const countAvailableUsers = this.$firebase.functions().httpsCallable('countAvailableUsersLastMonth')
      countAvailableUsers().then(val => {
        console.log('countAvailableUsersLastMonth:', val)
        if (val.data && val.data.status && val.data.status === 'ok') {
          this.lastMonthUsersCount = val.data.countLastMonthUsers || 0
        }
      }).catch(err => {
        console.log('countAvailableUsersLastMonth:', err)
      })
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
  .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  }
  .userItem{
    min-width: 100px;
  }
// .userItem {
//   display: flex;
//   .profIcon {
//     width: 5em;
//     height: 5em;
//     display: inline-block;
//     img {
//       width: 100%;
//       height: 100%;
//       object-fit: cover;
//       border-radius: 50%;
//     }
//   }
// }
.vue-js-switch.disabled {
  opacity: 1.0;
}

.vue-js-switch.unclickable {
  opacity: 0.6;
  pointer-events: none;
}

.cursor-div {
  cursor: pointer;
  cursor: hand;
}
.b-form-select {
  font-size:14px;
  border:1px;
}
.userInfo {
  display: flex;
  align-items: center;
}
.userInfo .search-userimg {
  margin-right: 1.5rem;
}
.center-align {
  text-align: center;
}
.btn-userDelete {
  width: 75px;
  height: 22px;
  line-height: 1px;
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/ManageUsers.vue